import { createAsyncThunk } from "@reduxjs/toolkit";
import { services } from "./service";

export const getAllReviews = createAsyncThunk(
  "review/getAllReviews",
  async (obj) => {
    try {
      return await services.getReviews(obj);
    } catch (error) {}
  }
);

export const createNewReview = createAsyncThunk(
  "review/createNewReview",
  async (obj) => {
    try {
      return await services.createReview(obj);
    } catch (error) {}
  }
);
